import angular from 'angular';

export default angular.module('cms.delete.element.dialog.service', [])
    .factory('deleteElementDialog', ($uibModal) => {

        let service = {};

        service.open = (content) => {
            let modalInstance = $uibModal.open({
                animation: true,
                template: require('./deleteElementModal.html'),
                size: 'md',
                resolve: { content: () => content} ,
                controller: ($scope, content) => {
                    $scope.content = content;
                }
            });

            return modalInstance.result;
        };


        return service;


    }).name


// WEBPACK FOOTER //
// ./src/cmsCore/DeleteElementModal/deleteElement.js